import { lrnsyCryptoService } from "./lrnsy-crypto.service";

class EncryptedLocalStorageService {
  private getDeviceSecret() {
    const key = "lrnsy_device_local_secret_v1";
    const existing = localStorage.getItem(key);
    if (existing) return existing;

    const created = lrnsyCryptoService.generatePrivateKey();
    localStorage.setItem(key, created);
    return created;
  }

  async setEncryptedJson(key: string, value: unknown) {
    const secret = this.getDeviceSecret();
    const encrypted = await lrnsyCryptoService.encryptText(JSON.stringify(value), secret);
    localStorage.setItem(key, JSON.stringify(encrypted));
  }

  async getEncryptedJson<T>(key: string): Promise<T | null> {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const secret = this.getDeviceSecret();
    const payload = lrnsyCryptoService.parseEncryptedValue(raw);
    if (!payload) return null;

    const decrypted = await lrnsyCryptoService.decryptText(payload, secret);
    return JSON.parse(decrypted) as T;
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }
}

export const encryptedLocalStorageService = new EncryptedLocalStorageService();
